import { ClientScoreHealthRangeProps } from '..';
import { ClientScoreHealthRange } from '../ScoreHealthRange';
import { QUALIFIED_TERM_SCORECARD_ELEMENT_SYMBOL } from '../../../Scorecard';
import { useHeadOfHouseholdMaxTargetScoreAgeGroup } from '../../../TargetScore';
import { getQtBreakpointsFromAgeGroup } from './util';

export function ClientQualifiedTermScoreHealthRange(props: Omit<ClientScoreHealthRangeProps, 'breakpoints' | 'element'>) {
  const { ageGroup, isHeadOfHouseholdMaxAgeLoading } = useHeadOfHouseholdMaxTargetScoreAgeGroup({
    firmID: props.firmID,
    firmClientID: props.firmClientID,
  });

  return (
    <ClientScoreHealthRange
      {...props}
      element={QUALIFIED_TERM_SCORECARD_ELEMENT_SYMBOL}
      externalLoading={isHeadOfHouseholdMaxAgeLoading}
      breakpoints={getQtBreakpointsFromAgeGroup(ageGroup)}
    />
  );
}
